module.exports = __webpack_public_path__ + "static/media/co-owner-user.90a425d5.png";